<template>
  <div class="header-container">
    <div class="header-single" @click="openSingle = true">
      <el-tooltip :content="$t('aheader.网络')" placement="bottom-start">
        <div class="header-single-icon">
          <img v-if="singleStatus.singleStatusTips == 2" :src="require('@/svg/single_bad.svg')" />
          <img
            v-if="singleStatus.singleStatusTips == 0"
            :src="require('@/svg/single_better.svg')"
          />
          <img
            v-if="singleStatus.singleStatusTips == 1"
            :src="require('@/svg/single_moderate.svg')"
          />
        </div>
      </el-tooltip>
      <!-- <span class="fontSize12">{{ $t("header.延迟") }}:500ms</span>
      <span class="fontSize12">{{ $t("header.丢包率") }}:0%</span> -->
    </div>
    <div class="header-liveInfo">
      <span class="liveTheme fontSize14">{{ liveTitle }}</span>
      <span
        class="liveStatus fontSize12"
        :class="liveStartStatus == 2 ? 'liveStatus' : 'notliveStatus'"
      >
        <span v-if="liveStartStatus == 2">{{ $t('header.直播中') }}</span>
        <span v-if="liveStartStatus == 3">{{ $t('aheader.已过期') }}</span>
        <span v-if="liveStartStatus == 4">{{ $t('aheader.已结束') }}</span>
        <span v-if="liveStartStatus == 1">{{ $t('aheader.准备中') }}</span>
        <span v-if="liveStartStatus == 0">{{ $t('aheader.未开始') }}</span>
      </span>
    </div>
    <div class="header-btn">
      <!-- <div
        class="no-rule"
        v-if="detected"
        :class="{ 'no-rule-show': !detectedNew }"
        @click="detectedShowList"
      >
        <span class="rule-icon" v-if="detectedNew">
          <img src="../../svg/violation.svg" />
        </span>
        <span v-else>
          <img src="../../svg/violation-show.svg" />
        </span>
        <span v-if="detectedNew">{{ $t("aheader.检测到页面违规") }}</span>
      </div> -->
      <priseReward />

      <!-- <el-divider direction="vertical"></el-divider> -->
      <div class="others">
        <el-tooltip :content="$t('aheader.浏览器异常提醒')" placement="bottom" v-if="isBrowserErr">
        <div class="header-btn-icon pointer" @click="browerErr">
          <img :src="require('@/svg/browser_err.svg')" />
        </div>
      </el-tooltip>
        <up/>
        <!-- 设置 -->
        <el-tooltip :content="$t('aheader.设置')" placement="top-start">
          <div class="header-btn-icon pointer" @click="setSetting">
            <img :src="require('@/svg/setting.svg')" />
          </div>
        </el-tooltip>

        <!-- <span class="line" v-if="isCustomerService || !isBrowserErr"></span> -->
        <el-tooltip :content="$t('aheader.在线客服')" placement="bottom" v-if="isCustomerService">
          <div class="header-btn-icon pointer">
            <a href="javascript:;" @click="customerServiceShow"
              ><img :src="require('@/svg/customer_service.svg')"
            /></a>
          </div>
        </el-tooltip>
      </div>
    </div>
    <single v-if="singleCurrent" :visible.sync="openSingle"></single>
    <singleOld v-else :visible.sync="openSingle"></singleOld>
    <!-- <ruleList v-if="ruleListShow" :ruleListShow.sync="ruleListShow" /> -->
  </div>
</template>

<script>
// import Bus from "@/components/doc/bus";
import single from '@/components/single/index';
import singleOld from '@/components/single/indexOld';
import { pushRoomMessageFunc } from '@/utils/socketMessageDispose';
import { device, getFFVer, getChromeVersion } from '@/utils/global';
import { mapGetters } from 'vuex';
import up from "@/components/upHost/up.vue";
import priseReward from '@/components/reward/priseReward.vue';
// import alteringIcon from "@/svg/altering.svg";
export default {
  name: 'aheader',
  computed: {
    ...mapGetters(['liveConfig', 'shareType', 'audioAudit']),
    avctl() {
      return this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.avctl;
    },
    liveTitle() {
      return this.$store.getters.liveTitle;
    },
    liveStartStatus() {
      return this.$store.getters.liveRoomStatus;
    },
    isPackUp() {
      return this.$store.getters.isPackUp;
    },
    ischangearea() {
      return this.$store.getters.isChangeArea;
    },
    publication() {
      let pubLocallication = null;
      if (
        this.rtcClient.RTCRoom.webrtc &&
        this.rtcClient.RTCRoom.webrtc.publishLocal &&
        this.rtcClient.RTCRoom.webrtc.publishLocal.publication
      ) {
        pubLocallication = this.rtcClient.RTCRoom.webrtc.publishLocal.publication;
      }
      return pubLocallication;
    },
    rtcClient() {
      return this.$store.getters.rtcClient;
    },
    videoStatus() {
      // return (
      //   this.$store.getters.selfParticipant &&
      //   this.$store.getters.selfParticipant.mediaStatus &&
      //   this.$store.getters.selfParticipant.mediaStatus.video
      // );
      console.log(this.$store.getters.selfParticipant, 'this.$store.getters.selfParticipant');
      return this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.mediaStatus
        ? this.$store.getters.selfParticipant.mediaStatus.video
        : 'disabled';
    },
    audioStatus() {
      return this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.mediaStatus
        ? this.$store.getters.selfParticipant.mediaStatus.audio
        : 'disabled';
    },
    userInfo() {
      return this.$store.getters.userInfo;
    },
    videoInputDeviceId() {
      return this.$store.getters.VideoInputDeviceId ? this.$store.getters.VideoInputDeviceId : true;
    },
    AudioInputDeviceId() {
      return this.$store.getters.AudioInputDeviceId ? this.$store.getters.AudioInputDeviceId : true;
    },
    publishStream() {
      let pubStream = null;
      if (
        this.rtcClient.RTCRoom.webrtc &&
        this.rtcClient.RTCRoom.webrtc.publishLocal &&
        this.rtcClient.RTCRoom.webrtc.publishLocal.publishStream
      ) {
        pubStream = this.rtcClient.RTCRoom.webrtc.publishLocal.publishStream;
      }
      return pubStream;
    },
    authAudio() {
      return (
        this.$store.getters.meetStatusInfo &&
        this.$store.getters.meetStatusInfo.groupInfo &&
        this.$store.getters.meetStatusInfo.groupInfo.audio
      );
    },
    authVideo() {
      return (
        this.$store.getters.meetStatusInfo &&
        this.$store.getters.meetStatusInfo.groupInfo &&
        this.$store.getters.meetStatusInfo.groupInfo.video
      );
    },
    isCustomerService() {
      return this.$store.getters.isCustomerService;
    },
    mediaStatus() {
      return this.$store.getters.mediaStatus;
    },
    selfType() {
      return this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.type;
    },
    disabledContent() {
      // 嘉宾身份，9:16模式下提示9:16视频无法开启摄像头
      if (
        this.selfType == 1 &&
        this.$store.state.liveInfo.liveConfig &&
        this.$store.state.liveInfo.liveConfig.video_source_ratio
      ) {
        return this.$t('video.videoSourceRatio');
      } else {
        return this.$t('aheader.视频已关闭');
      }
    },
    // audioAudit() {
    //   return this.$store.state.liveInfo.audioAudit;
    // },
    role() {
      //3:主播 2：助手 1：嘉宾
      return this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.type;
    }
  },
  components: {
    single,
    singleOld,
    priseReward,
    up
  },
  data() {
    return {
      openSingle: null,
      singleStatus: {
        singleStatusTips: 2, //0:较号 1：较弱 2：最弱
        changeNetTips: false, //控制信号最弱提示
        singleStatusChangeTimer: null,
        mixVideoInfo: [],
        badTimes: 0,
        continueReceiveFrameRateZeroTimes: 0, //接收远端流帧率为0持续次数
        continueSendFrameRateZeroTimes: 0,
        lastbytesReceived: 0,
        lastbytesSent: 0
      },
      bytesSent: null,
      isBaded: false,
      showLocal: false,
      showTips: true, //是否显示本地摄像头提示
      disabled: false,
      actMode: true,
      isBrowserErr: false,
      device: device(),
      singleCurrent: getChromeVersion() > 114
    };
  },
  watch: {
    'singleStatus.singleStatusTips'(val) {
      if (val === 2) {
        this.$message.error(this.$t('aheader.网络较差'));
      }
      this.$store.commit('SET_SIGNAL_STATUS', val);
    }
    // audioAudit: {
    //   handler(newValue, oldValue) {
    //     console.log(oldValue, "audioAudit");
    //     //如果是主播才显示
    //     if (newValue && this.role == 3) {
    //       this.detected = true;
    //     } else {
    //       this.detected = false;
    //     }
    //   },
    //   immediate: true,
    // },
  },
  created() {
    this.watchSingleStatus();
    window.__SET_BAD = () => {
      this.isBaded = true;
      this.singleStatus.singleStatusTips = 2;
    };
    this.browerErr();
    pushRoomMessageFunc(({ cmd, requestData }) => {
      const fn = this[`message_${cmd}`];
      typeof fn === 'function' && fn(requestData);
    });
  },
  mounted() {},
  methods: {
    // message_7127(body) {
    //   switch (body.event) {
    //     case "cloud_webcast_video_picture_data": {
    //       if (this.role == 3) {
    //         this.detected = true;
    //         this.detectedNew = true;
    //         if (!this.detectedMessage && !this.hasTips) {
    //           this.detectedPicture();
    //         }
    //       }
    //       break;
    //     }
    //     case 'TO_BE_MAIN_CONTROL':{
    //       if (body.role === "host") {
    //         console.log(this.audioAudit, "audioAudit....")
    //         if (this.audioAudit) {
    //           if (body.uid !== this.userInfo?.uid) {
    //             this.detected = false;
    //           } else{
    //             this.detected = true;
    //           }
    //         }
    //       }
    //       break;
    //     }
    //   }
    // },
    // detectedPicture() {
    //   this.hasTips = true;
    //   this.$confirm(
    //     `<div style="display:flex;justify-content: center;align-items: center;"><img src="${this.alteringUrl}" style="margin-right:10px;"/>${this.$t("aheader.系统检测到当前直播存在违规画面")}</div>`,
    //     `${this.$t('aheader.提示')}`,
    //     {
    //       confirmButtonText: this.$t('aheader.查看'),
    //       cancelButtonText: this.$t('aheader.不再提示'),
    //       dangerouslyUseHTMLString: true,
    //       distinguishCancelAndClose: true
    //     }
    //   )
    //     .then(() => {
    //       this.ruleListShow = true;
    //       this.detectedNew = false;
    //       this.hasTips = false;
    //       Bus.$emit("lists");
    //     })
    //     .catch((e) => {
    //       if(e === 'cancel'){
    //         this.detectedMessage = true;
    //       }
    //       this.hasTips = false;
    //     });
    // },
    /**
     * 点击打开违规列表
     */
    // detectedShowList() {
    //   this.detectedNew = false;
    //   this.ruleListShow = true;
    // },
    customerServiceShow() {
      const role = this.$store.getters.userRole == 6 ? '主播' : '嘉宾';
      let _customerServiceUrl = config.customerServiceUrl;
      const device = `CLA-WEB`;
      _customerServiceUrl = _customerServiceUrl.replace(
        /&_params=/g,
        `&params={"source":"${encodeURIComponent(
          window.location.href
        )}","device":"${device}","role":"${encodeURIComponent(role)}"}`
      );
      window.open(`${_customerServiceUrl}`, '_blank');
    },
    setSetting() {
      this.$store.commit('SHOW_SETTING', true);
    },
    browerErr() {
      var myVideo = document.createElement('video');
      var isSupport = false;
      if (myVideo.canPlayType) {
        if (this.device.isFireFox && getFFVer() > 66) {
          isSupport = true;
        } else if (this.device.isChrome && getChromeVersion() > 75) {
          isSupport = true;
        } else if (
          !this.device.isFireFox &&
          !this.device.isChrome &&
          '' != myVideo.canPlayType('video/mp4;codecs="avc1.64001E"')
        ) {
          isSupport = true;
        }
      }
      this.isBrowserErr = !window.RTCPeerConnection || !isSupport;
      // 判断是否支持webrtc
      if (!window.RTCPeerConnection || !isSupport) {
        let tipsObj = {
          confirmButtonText: this.$t('aheader.下载Chrome'),
          customClass: 'tip-alert text-left',
          cancelButtonText: this.$t('aheader.忽略')
        };
        this.$confirm(this.$t('aheader.您当前的浏览器版本过低'), this.$t('aheader.提示'), tipsObj)
          .then(() => {
            window.open('https://www.google.cn/intl/zh-CN/chrome/');
          })
          .catch(() => {});
      }
    },

    // handleMessage4129(requestData){
    //   console.log(requestData.set," requestData.set");
    // },
    // changeCamera() {
    //   // if (this.avctl && !this.authVideo && this.videoStatus == "inactive") {
    //   //   return;
    //   // }
    //   // 2.0.10 允许嘉宾与主播关闭音视频设备
    //   if (
    //     this.videoStatus == "inactive" &&
    //     this.authVideo == 0 &&
    //     this.avctl == 0
    //   )
    //     return;
    //   if (this.disabled) return;
    //   const status = this.videoStatus == "active" ? "inactive" : "active";
    //   this.rtcClient.RTCRoom.handleParticipantCamera(
    //     this.userInfo.uid,
    //     this.userInfo.cid,
    //     status
    //   ).then(() => {
    //     // if (status == "inactive" && this.publishStream && this.publishStream.getVideoTracks()[0]) {
    //     //   this.publishStream.getVideoTracks()[0].enabled = false;
    //     // } else if (this.publishStream && this.publishStream.getVideoTracks()[0]) {
    //     //   this.publishStream.getVideoTracks()[0].enabled = true;
    //     // }
    //     this.$store.commit("SET_SELFVIDEOSTATUS", status);
    //   });
    // },
    // showSetting() {
    //   this.$store.commit("SHOW_SETTING", true);
    // },
    // handelPackUpBtn() {
    //   this.$store.commit("SET_ISPACKUP", !this.isPackUp);
    // },

    /**检测信号状态
     * 规则：已远端流视频数据为基准:5s的平均值
     * 丢包率： >= 0 && <10 good    >=10 &&<20 normal   >=30 bad
     * 分辨率： 1080P 720p god    360p normal
     * 帧率： >=20 god   >=10 && <20 normal  <10 && >=0 bad
     * **/
    watchSingleStatus() {
      let mixVideoInfo;
      this.singleStatus.singleStatusChangeTimer = setInterval(async () => {
        if (!this.rtcClient || !this.rtcClient.RTCRoom) return;
        if (this.singleCurrent) {
          mixVideoInfo = await this.rtcClient.RTCRoom.getSendStatusCurrent('local');
        } else {
          mixVideoInfo = await this.rtcClient.RTCRoom.getSendStatus('local');
        }
        //console.log(mixVideoInfo, "mixVideoInfo......")
        if (!mixVideoInfo) return;
        mixVideoInfo = mixVideoInfo.video || mixVideoInfo.audio;
        if (!mixVideoInfo) {
          this.singleStatus.singleStatusTips = 2;
          return;
        }
        this.singleStatus.mixVideoInfo.push(mixVideoInfo);
        //console.log(this.singleStatus, "singleStatus.....")
        if (this.singleStatus.mixVideoInfo.length > 1) {
          const mixVideoInfoLength = this.singleStatus.mixVideoInfo.length,
            mixVideoInfoBefore = this.singleStatus.mixVideoInfo[0],
            mixVideoInfoAfter = this.singleStatus.mixVideoInfo[mixVideoInfoLength - 1];
          // 平均丢包率
          var avgPacketLostRate = parseInt(
            ((mixVideoInfoAfter.nackCount - mixVideoInfoBefore.nackCount) /
              (mixVideoInfoAfter.packetsSent - mixVideoInfoBefore.packetsSent)) *
              100
          );
          // console.log(
          //   `%c${mixVideoInfoAfter.nackCount}-${mixVideoInfoBefore.nackCount}`,
          //   "color:green;font-size:14px"
          // );
          // console.log(
          //   `%c${mixVideoInfoAfter.packetsSent}-${mixVideoInfoBefore.packetsSent}`,
          //   "color:red;font-size:14px"
          // );
          var avgFrameRate = null;
          // var avgResolution = null;
          var frameRate = null;
          var resolution = null;
          // console.log(this.singleStatus.mixVideoInfo);
          this.singleStatus.mixVideoInfo.forEach((mixVideoInfo, index) => {
            frameRate = frameRate + mixVideoInfo.framesPerSecond;
            resolution = resolution + mixVideoInfo.frameHeight;
            if (index == this.singleStatus.mixVideoInfo.length - 1) {
              avgFrameRate = parseInt(frameRate / (index + 1));
              // avgResolution = parseInt(resolution / (index + 1));
            }
          });
          if (avgPacketLostRate >= 20 || (avgFrameRate >= 0 && avgFrameRate < 10)) {
            this.singleStatus.singleStatusTips = 2; //
            if (
              (this.singleStatus.badTimes == 60 && !this.singleStatus.changeNetTips) ||
              this.singleStatus.badTimes == 0
            ) {
              this.singleStatus.changeNetTips = true;
            }
            if (this.singleStatus.badTimes == 60) {
              this.singleStatus.badTimes = 0;
            }
            if (this.singleStatus.badTimes != 0) {
              this.singleStatus.badTimes++;
            }
          } else if (
            (avgPacketLostRate < 20 && avgPacketLostRate >= 10) ||
            (avgFrameRate >= 10 && avgFrameRate < 20)
          ) {
            this.singleStatus.singleStatusTips = 1;
            this.singleStatus.changeNetTips = false;
            this.singleStatus.badTimes = 0;
          } else if (avgPacketLostRate > 20 || avgFrameRate > 20) {
            if (!this.isBaded) {
              this.singleStatus.singleStatusTips = 0;
            }
            this.singleStatus.changeNetTips = false;
            this.singleStatus.badTimes = 0;
          }
        }
        // console.log(`5s内的平均帧率：${avgFrameRate}`);
        // console.log(`分辨率${avgResolution}p`);
        // console.log(`5s内的平均丢包率：${parseInt(avgPacketLostRate)}`);

        if (this.singleStatus.mixVideoInfo.length > 5) {
          this.singleStatus.mixVideoInfo.splice(0, 1);
        }
        //连续10次获得发送字节不变化，则发布远端流
        //                  console.log(mixVideoInfo);
        if (mixVideoInfo.bytesSent != undefined && this.bytesSent == mixVideoInfo.bytesSent) {
          this.singleStatus.continueReceiveFrameRateZeroTimes++;
          if (this.singleStatus.continueReceiveFrameRateZeroTimes == 10) {
            // console.log("连续10次获得发送字节不变化，则发布远端流");
          }
        } else {
          this.singleStatus.continueReceiveFrameRateZeroTimes = 0;
        }
        //根据发送帧率判断：连续10次获得发送流帧率为0，则重新发送本地流
        if (mixVideoInfo.bytesSent != undefined && this.lastbytesSent == mixVideoInfo.bytesSent) {
          this.singleStatus.continueSendFrameRateZeroTimes++;
          if (this.singleStatus.continueSendFrameRateZeroTimes == 10) {
            // console.log("连续10次获得发送本地字节不变化，则重新发送本地流");
          }
        } else {
          this.singleStatus.continueSendFrameRateZeroTimes = 0;
        }
        this.lastbytesSent = mixVideoInfo.bytesSent;
        // console.log(this.singleStatus.mixVideoInfo);
      }, 1000);
      setInterval(() => {
        this.logger.info({
          code: 2012,
          message: mixVideoInfo
        });
      }, 30000);
    },
    /* 回归信号状态初始值 */
    initSingleStatus() {
      if (this.singleStatus.singleStatusChangeTimer) {
        clearInterval(this.singleStatus.singleStatusChangeTimer);
        this.singleStatus.singleStatusChangeTimer = null;
      }
    },
    showLocalVideo() {
      this.showLocal = !this.showLocal;
      this.showTips = false;
      this.getLocalVideo();
    },
    getLocalVideo() {
      let _this = this;
      if (this.publishStream) {
        var video = document.querySelector('video');
        video.srcObject = this.publishStream;
        _this.disabled = false;
      } else {
        _this.disabled = true;
      }
    },
    changeMicStatus() {
      if (
        this.liveConfig?.liveondemandVoiceStatus === 0 &&
        (this.mediaStatus == 2 || this.mediaStatus == 3)
      ) {
        this.$message.error(this.$t('lianmai.插播静音已开启，您暂时不能开关麦克风'));
        return;
      }
      console.log(this.authAudio + ',' + this.avctl + ',' + this.audioStatus, '声音变量');
      //如果是主控模式不能打开摄像头
      // if (this.avctl && !this.authAudio && this.audioStatus == "inactive") {
      //   return;
      // }
      // 2.0.10 允许嘉宾与主播关闭音视频设备
      if (this.audioStatus == 'inactive' && this.avctl == 0 && this.authAudio == 0) return;
      // const status = this.audioStatus === "active" ? "inactive" : "active";
      // this.audioStatus == "active" ?  window.document.documentElement.setAttribute( "data-theme", 'Blue' ) :  window.document.documentElement.setAttribute( "data-theme", 'Orange' );
      // Bus.$emit('changeTheme',this.audioStatus == "active"?'blue':'orange')
      let status = 'inactive';
      if (this.audioStatus == 'active') {
        status = 'inactive';
      } else {
        status = 'active';
      }
      this.rtcClient.RTCRoom.muteParticipant(this.userInfo.uid, this.userInfo.cid, status).then(
        () => {
          console.log('开启关闭声音', status);
          this.$store.commit('SET_SELFAUDIOSTATUS', status);
        }
      );
    },
    closeTips() {
      this.showTips = false;
    },
    closeLocalVideo() {
      this.showLocal = false;
    }
  }
};
</script>

<style scoped lang="scss">
.header-container {
  display: flex;
  justify-content: space-between;

  .header-single {
    margin-left: 10px;

    > span {
      color: $grey2-color;
      margin: 0px 10px 0px 10px;
    }

    .header-single-icon {
      width: 24px;
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
    }
  }

  .header-liveInfo {
    .liveTheme {
      color: $grey-color;
      margin-right: 16px;
      max-width: 576px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      vertical-align: middle;
      display: inline-block;
    }

    .liveStatus {
      color: $red-color;
      border: 1px solid $red-color;
      padding: 4px 12px;
      border-radius: 16px;
    }

    .notliveStatus {
      color: $bule-color;
      border: 1px solid $bule-color;
      padding: 4px 12px;
      border-radius: 16px;
    }
  }

  .header-btn-icon {
    display: inline-block;
    overflow: hidden;
    margin-right: 16px;
  }

  .poper-video {
    padding: 0;
  }
}

.show-tips {
  position: absolute;
  right: 100px;
  z-index: 100;
  top: 50px;
  background-color: rgba($color: #000000, $alpha: 0.8);
  border: 1px solid #000;
  color: rgba($color: #fff, $alpha: 0.8);
  font-size: 12px;
  padding: 2px 6px;
  cursor: pointer;
  border-radius: 3px;
}

.pack_show-tips {
  right: 20px;
}

.show-tips:after,
.show-tips:before {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border: 4px solid transparent;
  border-bottom-color: rgba($color: #000000, $alpha: 0.8);
  right: 36px;
  bottom: 45px;
}

.pack_show-tips:after,
.pack_show-tips:before {
  right: 30px;
}

.audio-disable {
  opacity: 0.5;
  cursor: default;
}

.line {
  width: 1px;
  height: 16px;
  background-color: #3a4050;
  display: inline-block;
  margin-right: 16px;
}

.header-btn {
  display: flex;
  align-items: center;

  img {
    vertical-align: middle;
  }
}

.fontSize14 {
  font-size: 14px;
}
// .no-rule {
//   color: #fff;
//   width: 110px;
//   height: 24px;
//   background: #ea494b;
//   border-radius: 12px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   cursor: pointer;
//   margin-right: 16px;
//   font-size: 10px;
// }
// .no-rule-show {
//   width: 24px;
//   background: none;
// }
// .rule-icon {
//   display: flex;
//   margin-right: 2px;
// }
.others {
  display: flex;
  margin-left: 8px;
}
</style>
<style>
.el-message-box__title {
  color: #fff;
  font-size: 16px;
}
[data-theme='Orange'] .el-message-box__title {
  color: #3e3f41;
}
</style>
